import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import AlertInfo from './AlertInfo';
import AlertTable from './AlertTable';
import { hasAiAlertSelector, selectedAiAlertSelector } from '@store/trends/aiAlerts/selectors';
import HeatMap from './HeatMap';
import { PanelRow } from '../styled';
import { useGlobalFeature } from '@src/globalStore/globalFeatureFlagsStore';
import { globalFeatureNames } from '@src/utils/featureToggle/constants';
import AICohortDrawer from '@src/components/ai-alerts/HeaderPanel/AICohort';
import { useAtom } from 'jotai';
import { aiCohortDrawerAtom } from '@src/components/ai-alerts/HeaderPanel/SensitivityControl/atoms';

function AIAlert() {
  const hasAiAlert = useSelector(hasAiAlertSelector);
  const alert = useSelector(selectedAiAlertSelector);
  const [isExpand, setIsExpand] = useState(true);
  const enableDPICustomDimension = useGlobalFeature(globalFeatureNames.DPI_CUSTOM_DIMENSION);
  const [openAICohortDrawer, setOpenAICohortDrawer] = useAtom(aiCohortDrawerAtom);

  if (!hasAiAlert || isEmpty(alert)) {
    return null;
  }

  return (
    <>
      <PanelRow>
        <div style={{ flexBasis: isExpand ? '100%' : '30%', minWidth: '530px' }}>
          <AlertInfo alert={alert} setIsExpand={setIsExpand} isExpand={isExpand} />
        </div>
        {isExpand ? null : (
          <>
            <div style={{ flexBasis: '40%' }}>
              <AlertTable alert={alert} />
            </div>
            <div style={{ flexBasis: '20%' }}>
              <HeatMap alert={alert} />
            </div>
          </>
        )}
      </PanelRow>
      {/* AI Cohort Drawer */}
      <AICohortDrawer
        visible={openAICohortDrawer.open}
        onClose={() => setOpenAICohortDrawer({ open: false, metrics: [], key: '', isFlow: false })}
        sensitivityConfigDrawerOpen={false}
      />
    </>
  );
}

export default AIAlert;
